import {
  type AnchorLabelContext,
  getAnchorLabel,
} from 'features/libra/comments/anchorLabels'
import type { ThreadMetaEntry } from 'features/libra/comments/commentsApi'
import { ticketLink } from 'features/libra/dashboard/ticketDashboard/libra/ticketLink'
import type {
  ItemView,
  Pill,
} from 'features/libra/dashboard/ticketDashboard/types'
import {
  componentOntologyFieldsOf,
  ticketOntologyFieldsOf,
} from 'features/libra/ontology/useOntologyFields'
import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import type { LibraWorkflow } from 'features/libra/workflow/workflowStepsApi'

import { COMMENTS_CATEGORY } from './categoryIds'

function labelContext(workflow: LibraWorkflow): AnchorLabelContext {
  const { ontologyFields } = workflow.globalContext
  return {
    workflow,
    ontologyFields: ticketOntologyFieldsOf(ontologyFields),
    componentOntologyFields: componentOntologyFieldsOf(ontologyFields),
  }
}

/**
 * Unresolved thread count, listing each thread by where it's anchored. No pill
 * at zero.
 */
export function commentsPill(
  ticket: LibraTicket,
  workflow: LibraWorkflow | undefined,
  threads: ReadonlyArray<ThreadMetaEntry>
): Pill | undefined {
  if (threads.length === 0) return undefined
  const context = workflow && labelContext(workflow)
  const items = threads.map(
    (thread): ItemView => ({
      id: thread.entryId,
      title: context ? getAnchorLabel(thread.anchor, context) : 'Comment',
      link: ticketLink(ticket, 'Go to comment', thread.entryId),
    })
  )
  return {
    category: COMMENTS_CATEGORY,
    value: 'unresolved',
    label: String(threads.length),
    tooltip:
      threads.length === 1
        ? '1 unresolved comment'
        : `${threads.length} unresolved comments`,
    tone: 'warning',
    icon: 'MessageSquareText',
    info: { items },
  }
}
